export default __webpack_public_path__ + "static/media/mariog4.62fd0325.jpg";